import { lazy } from "react";
import i18n from "i18next";
import type { GameModule } from "../types";
import { FALLING_BLOCKS_NS, registerFallingBlocksTranslations } from "./i18n";

registerFallingBlocksTranslations(i18n);

/** Cascade (ADR 0077). Keyed `falling_blocks`; the name people see comes from i18n. */
export const fallingBlocksModule: GameModule = {
  key: "falling_blocks",
  namespace: FALLING_BLOCKS_NS,
  Player: lazy(() => import("./Player")),
};
